import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const location = useLocation();

  const navigationItems = [
    { name: 'Browse Products', href: '/product-catalog-browse', icon: 'Grid3X3' },
    { name: 'New Arrivals', href: '/new-arrivals-showcase', icon: 'Sparkles' }
    // { name: 'Sale', href: '/sale', icon: 'Tag' },
    // { name: 'Collections', href: '/collections', icon: 'Layers' },
  ];

  const isActiveRoute = (href) => {
    return location?.pathname === href;
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background border-b border-border shadow-soft">
      <div className="w-full">
        <div className="flex items-center justify-between h-16 px-4 lg:px-6">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2">
              {/* <img 
                src="/assets/images/brandsoflegends.jpg" 
                alt="Brands of Legends" 
                className="w-12 h-12 rounded-lg object-cover"
              /> */}
              <span className="text-xl font-semibold text-primary">BRANDS OF LEGENDS</span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navigationItems?.map((item) => (
              <Link
                key={item?.name}
                to={item?.href}
                className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-150 ${
                  isActiveRoute(item?.href)
                    ? 'text-accent bg-accent/10' :'text-secondary hover:text-primary hover:bg-muted'
                }`}
              >
                <Icon name={item?.icon} size={16} />
                <span>{item?.name}</span>
              </Link>
            ))}
          </nav>

          {/* Right Actions */}
          <div className="flex items-center space-x-4">
            {/* Search */}
            <div style={{ visibility: isMobileMenuOpen ? 'hidden' : 'hidden' }} className="relative">
              {isSearchOpen ? (
                <div className="flex items-center space-x-2">
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Search shoes..."
                      className="w-64 pl-10 pr-4 py-2 bg-input border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
                      autoFocus
                    />
                    <Icon 
                      name="Search" 
                      size={16} 
                      className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" 
                    />
                  </div>
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={toggleSearch}
                  >
                    <Icon name="X" size={16} />
                  </Button>
                </div>
              ) : (
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={toggleSearch}
                  className="hidden lg:flex"
                >
                  <Icon name="Search" size={20} />
                </Button>
              )}
            </div>

            {/* Wishlist */}
            <Button variant="ghost" size="icon" className="relative hidden lg:flex" style={{ visibility: isMobileMenuOpen ? 'hidden' : 'hidden' }}>
              <Icon name="Heart" size={20} />
              <span className="absolute -top-1 -right-1 bg-accent text-accent-foreground text-xs rounded-full w-5 h-5 flex items-center justify-center">
                3
              </span>
            </Button>

            {/* Cart */}
            <Button variant="ghost" size="icon" className="relative hidden lg:flex" style={{ visibility: isMobileMenuOpen ? 'hidden' : 'hidden' }}>
              <Icon name="ShoppingBag" size={20} />
              <span className="absolute -top-1 -right-1 bg-accent text-accent-foreground text-xs rounded-full w-5 h-5 flex items-center justify-center">
                2
              </span>
            </Button>

            {/* User Account */}
            <Button variant="ghost" size="icon" className="hidden lg:flex" style={{ visibility: isMobileMenuOpen ? 'hidden' : 'hidden' }}>
              <Icon name="User" size={20} />
            </Button>

            {/* Mobile Menu Toggle */}
            <Button
              variant="ghost"
              size="icon"
              onClick={toggleMobileMenu}
              className="lg:hidden"
            >
              <Icon name={isMobileMenuOpen ? "X" : "Menu"} size={20} />
            </Button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="lg:hidden border-t border-border bg-background">
            <div className="px-4 py-4 space-y-2">
              {/* Mobile Search */}
              <div className="relative mb-4" style={{ visibility: isMobileMenuOpen ? 'visible' : 'hidden' }}>
                 <a href="https://wa.me/96170863807" target="_blank" rel="noopener noreferrer">
                <Button variant="ghost" size="icon">
                  <Icon name="Phone" size={20} />
                </Button>
                <span className="text-sm text-muted-foreground">+961 70 863807</span>
                </a>
                {/* <input
                  type="text"
                  placeholder="Search shoes..."
                  className="w-full pl-10 pr-4 py-2 bg-input border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
                />
                <Icon 
                  name="Search" 
                  size={16} 
                  className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" 
                /> */}
              </div>

              {/* Mobile Navigation Items */}
              {navigationItems?.map((item) => (
                <Link
                  key={item?.name}
                  to={item?.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`flex items-center space-x-3 px-3 py-3 rounded-lg text-base font-medium transition-colors duration-150 ${
                    isActiveRoute(item?.href)
                      ? 'text-accent bg-accent/10' :'text-secondary hover:text-primary hover:bg-muted'
                  }`}
                >
                  <Icon name={item?.icon} size={20} />
                  <span>{item?.name}</span>
                </Link>
              ))}

              {/* Mobile Account Actions */}
              <div className="pt-4 mt-4 border-t border-border space-y-2" style={{ visibility: isMobileMenuOpen ? 'hidden' : 'hidden' }}>
                <Link
                  to="/account"
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="flex items-center space-x-3 px-3 py-3 rounded-lg text-base font-medium text-secondary hover:text-primary hover:bg-muted transition-colors duration-150"
                >
                  <Icon name="User" size={20} />
                  <span>My Account</span>
                </Link>
                <Link
                  to="/orders"
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="flex items-center space-x-3 px-3 py-3 rounded-lg text-base font-medium text-secondary hover:text-primary hover:bg-muted transition-colors duration-150"
                >
                  <Icon name="Package" size={20} />
                  <span>My Orders</span>
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;